import { css } from "@emotion/css";
import { md, sm } from "src/styles/utility";
import tw from "src/utils/tw";
// import colors from "src/utils/colors";

export default function AdminClassRoster(props) {
  return (
    <div>
      <div className="border-t border-borderGray">
        <div className="px-4 py-2">
          <p className="mb-1 text-sm">
            <strong>Enrolled</strong>
          </p>
          {props.roster.map((u) => (
            <div
              key={u.id}
              className={tw(
                css({
                  display: "inline-block",
                  width: "25%",
                  verticalAlign: "top",
                  [`@media (${md})`]: {
                    width: "33%",
                  },
                  [`@media (${sm})`]: {
                    width: "48%",
                  },
                }),
                "text-sm"
              )}
            >
              {u.firstName} {u.lastName}
            </div>
          ))}
        </div>
      </div>

      {props.pending.length > 0 && (
        <div className="border-t border-borderGray">
          <div className="px-4 py-2">
            <p className="mb-1 text-sm">
              <strong>Pending</strong>
            </p>
            {props.pending.map((u) => (
              <div
                key={u.id}
                className={tw(
                  css({
                    display: "inline-block",
                    width: "25%",
                    verticalAlign: "top",
                    [`@media (${md})`]: {
                      width: "33%",
                    },
                    [`@media (${sm})`]: {
                      width: "48%",
                    },
                  }),
                  "text-sm"
                )}
              >
                {u.firstName} {u.lastName}
              </div>
            ))}
          </div>
        </div>
      )}

      {props.waitlist.length > 0 && (
        <div className="border-t border-borderGray">
          <div className="px-4 py-2">
            <p className="mb-1 text-sm">
              <strong>Waitlist</strong>
            </p>
            {props.waitlist.map((u) => (
              <div
                key={u.id}
                className={tw(
                  css({
                    display: "inline-block",
                    width: "25%",
                    verticalAlign: "top",
                    [`@media (${md})`]: {
                      width: "33%",
                    },
                    [`@media (${sm})`]: {
                      width: "48%",
                    },
                  }),
                  "text-sm"
                )}
              >
                {u.firstName} {u.lastName}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
